// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__1ow_1","form":"styles_form__2KVGZ"};